import { Component } from '@angular/core';
import { NavController, Events, App, ViewController } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { AppSettings } from '../../../../config/app-settings';
import { PageBaseFull } from '../../../../core/page-base.full';
import { ForgotPasswordCommon } from './forgot-password.common';
import { PageRef } from '../../../../core/core.module';
import { Helpers } from '../../../../providers/helpers';
@Component({
	selector: 'page-forgot-password-full',
  	templateUrl: 'forgot-password.full.html'
})

export class ForgotPasswordPageFull extends PageBaseFull{
	public forgotPass: {email?: string} = {};
	public submitted = false;
    public errorMsg:string;

	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public events: Events,
		public common: ForgotPasswordCommon,
    	public pageRef: PageRef,
		public app: App,
    	public viewCtrl: ViewController,
		public helpers: Helpers
	) {
		super(settings, events, nav, userData);
		console.log("Loading Forgot Password Full");
	}
	emailRegx : RegExp = /^[^!'"\/ ]+$/;
	showInvalid : boolean = false; 
	ionViewDidEnter() {
		this.app.setTitle('Forgot Password');
	}

	ngAfterViewInit() {
		this.common.commonMethod();
	}

	public send(form){
		let self = this;
		self.showInvalid = true;
		if(!form.valid){
			self.showInvalid = false;
			return;
		}
    	this.userData.sendPasswordResetEmail(self.forgotPass.email).subscribe((res)=>{
			if(res.success){
				self.forgotPass.email = '';
				self.helpers.toast('Password reset link has been sent to your email address');
			}else{
				self.helpers.alert('Change Pasword',res.msg);
			}
    	});
	}

	public dismiss() {
        this.viewCtrl.dismiss();
        this.nav.setRoot(this.pageRef.get('home'));
    }

}



// WEBPACK FOOTER //
// ./src/modules/account/pages/forgot-password/forgot-password.full.ts